module.exports = __webpack_public_path__ + "img/ico-draw.0737ecfd.png";